<template>
  <div class="checklist-base-container" :class="{hoverable}">
    <div class="checklist-base-content">
      <div class="checklist-base-left-actions persist">
        <slot name="leftActions" />
      </div>

      <slot />

      <div
        class="checklist-base-actions"
        v-if="buttonsPreset != 'none' && buttonsPreset != 'save'"
      >
        <BaseIconButton
          variant="ghost"
          size="sm"
          icon="pencil"
          @click="$emit('edit')"
          textColor="content-base-secondary"
          textHoverColor="content-base-primary"
          bgColor="overlay-8"
          v-if="buttonsPreset == 'edit'"
        />
        <BaseIconButton
          variant="ghost"
          size="sm"
          @click="$emit('commonAction', 'move-up')"
          icon="arrow-up"
          textColor="content-base-secondary"
          textHoverColor="content-base-primary"
          bgColor="overlay-8"
          v-if="!buttonsData.firstBlock"
        />
        <BaseIconButton
          variant="ghost"
          size="sm"
          @click="$emit('commonAction', 'move-down')"
          icon="arrow-down"
          textColor="content-base-secondary"
          textHoverColor="content-base-primary"
          bgColor="overlay-8"
          v-if="!buttonsData.lastBlock"
        />
        <BaseIconButton
          variant="ghost"
          size="sm"
          icon="copy"
          @click="$emit('commonAction', 'copy')"
          textColor="content-base-secondary"
          textHoverColor="content-base-primary"
          bgColor="overlay-8"
          v-if="buttonsPreset == 'copy'"
        />
        <BaseIconButton
          variant="ghost"
          size="sm"
          icon="trash"
          @click="$emit('commonAction', 'delete')"
          textColor="content-base-secondary"
          textHoverColor="content-error-primary"
          bgColor="overlay-8"
        />
      </div>

      <div
        class="checklist-base-actions persist"
        v-if="buttonsPreset == 'save'"
      >
        <BasePushButton
          @click="$emit('save')"
          variant="fill"
          size="md"
          bgColor="background-success-primary"
          textColor="content-base-inverse-primary"
        >
          Save
        </BasePushButton>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    buttonsPreset: {
      type: String,
      default: "edit",
      validator: (v) => ["edit", "none", "copy", "save"].includes(v),
    },
    buttonsData: {
      type: Object,
      default: () => ({})
    },
    hoverable: {
      type: Boolean,
      default: true
    }
  },
};
</script>

<style>
.checklist-block-iqos-footer {
  background: var(--qrw-background-base-secondary);
  padding: 16px;
  flex-direction: row;
  display: flex;
  align-items: center;
  box-sizing: border-box;
  width: 100%;
  column-gap: 24px;
}

.checklist-block-iqos-body {
  padding: 0 !important;
}

.checklist-block-iqos-body-block {
  padding: 16px;
}
</style>

<style scoped>
.checklist-base-container {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  justify-items: center;
  padding: 24px 0px;
  flex-direction: column;
}

.checklist-base-container.hoverable:hover {
  background: var(--qrw-background-base-secondary);
}

.checklist-base-container:hover .checklist-base-actions {
  display: flex;
}

.checklist-base-actions {
  display: none;
  column-gap: 12px;

  position: absolute;

  left: calc(800px + 24px);

  top: 0;
  bottom: 0;

  margin: auto;

  height: 32px;
}

.checklist-base-left-actions {
  display: none;
  column-gap: 12px;

  position: absolute;

  right: calc(800px + 24px);

  top: 0;
  bottom: 0;

  margin: auto;

  height: 32px;
}

.checklist-base-content {
  display: flex;
  width: 800px;
  max-width: 800px;
  flex-direction: column;
  row-gap: 12px;
  position: relative;
}

.persist {
  display: flex;
}
</style>
